import React from "react"
import { Outlet, useLocation } from "react-router-dom"
import Navbar from "./components/marketing/Navbar"
import Footer from "./components/marketing/Footer"

export default function Layout() {
  const location = useLocation()

  // Determine current page name from path
  const getPageName = (pathname) => {
    const routes = {
      "/": "Home",
      "/about": "About",
      "/services": "Services",
      "/demos": "Demos",
      "/contact": "Contact",
      "/admin": "Admin"
    }
    return routes[pathname] || "Home"
  }

  const currentPageName = getPageName(location.pathname)

  return (
    <div className="bg-slate-950 min-h-screen flex flex-col">
      <Navbar currentPageName={currentPageName} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
